/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobStatusQueryOperator>): PolicyJobStatusQueryOperator {
        let obj = Object.assign(new PolicyJobStatusQueryOperator(), model);
        PolicyJobStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobStatusQueryOperator>): PolicyJobStatusQueryOperator {
        if (!model) return null;
        return PolicyJobStatusQueryOperator.newInstance(<PolicyJobStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobStatusQueryOperator) {
        if (!obj) return;

        models.PolicyJobStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy job statuses to include
     */
    statuses: Array<models.PolicyJobStatus>;

}
